const WhereEventNames = {
    DO_ROUTING : "do_routing",
    AFTER_ROUTING_RES : "after_routing_res",
    ADD_MARKERS : "add_markers"
}
export default WhereEventNames;